import { http } from './http_service';

//Get all
export function all(){
    return http().get('/financier');
}
//Get all active
export function allActive(){
    return http().get('/financier/active');
}
//Get List for table view with - Pagination
export function listPage(obj){
  let params = {
      page:obj.page,
      recordsPerPage:obj.recordsPerPage,
      q:obj.q,
      selectedStatus:obj.selectedStatus,
      sort_direction:obj.sort_direction,
      sort_field:obj.sort_field
  }
  return http().get(`/financier/list-page`, {
      params:params
  });
}

//Dropdown all (active and inactive)
export function dropdownAllList(){
  return http().get('/financier/dropdown-all/list');
}

//Dropdown
export function dropdownList(){
  return http().get('/financier/dropdown/list');
}
//Get Single
export function single(id){
    return http().get(`/financier/${id}`);
}
//Add one
export function add(data){
    return http().post('/financier', data)
}
//Update
export function update(id, data){
    return http().put(`/financier/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/financier/${id}`);
}
